@if (item.access){
@if (item.subItems){
<button mat-button [matMenuTriggerFor]="menu" (menuOpened)="ouvert()" [class.icon-only]="!item.title">
    @if (item.title){
    {{item.title}} <i class="fas fa-caret-down"></i>
    } @else {
    <ng-container *ngTemplateOutlet="iconSeulement" />
    }
</button>
<mat-menu #menu="matMenu" [hasBackdrop]="true">
    @for (sub of item.subItems; track sub){
    <button mat-menu-item (click)="clickItem(sub)" [hidden]="!sub.access">{{sub.title}}</button>
    }
</mat-menu>
} @else {
@if (item.title){
<a class="nav-link " (click)="clickItem(item)">{{item.title}}</a>
} @else {
@if (item.title){
{{item.title}} <i class="fas fa-caret-down"></i>
} @else {
<ng-container *ngTemplateOutlet="iconSeulement" />
}
}
}

<ng-template #iconSeulement>
    @if (item.subItems){
    <i class="{{item.icon}} icon-only"></i>
    }
    @else {
    <button mat-button [class.icon-only]="true">
        <i class="{{item.icon}} icon-only"></i>
    </button>
    }
</ng-template>
}